import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeManagementReportSummaryRowCreate,
  detail: routeManagementReportSummaryRowDetail,
  home: routeManagementReportSummaryRowsHome,
  root: routeManagementReportSummaryRowsRoot,
} = createDoctypeRoutes({
  createName: 'new-management-report-summary-row',
  createPath: 'new-management-report-summary-row',
  detailName: 'managementReportSummaryRowDetail',
  doctype: DOCTYPES.TW_MANAGEMENT_REPORT_SUMMARY_ROW,
  homeName: 'management-report-summary-rows',
  path: 'management-report-summary-rows',
  views: {
    create: async () =>
      await import(
        '@/components/viewsExternal/settings/accounting/reportMapping/AddManagementReportSummaryRow.vue'
      ),
    detail: async () =>
      await import(
        '@/components/viewsExternal/settings/accounting/reportMapping/ViewManagementReportSummaryRow.vue'
      ),
    list: async () =>
      await import('@/components/viewsExternal/settings/accounting/ViewAccountingSettings.vue'),
  },
})

export {
  routeManagementReportSummaryRowCreate,
  routeManagementReportSummaryRowDetail,
  routeManagementReportSummaryRowsHome,
  routeManagementReportSummaryRowsRoot,
}
